import { render, staticRenderFns } from "./ListTraceabilityTag.vue?vue&type=template&id=26480872"
import script from "./ListTraceabilityTag.vue?vue&type=script&lang=js"
export * from "./ListTraceabilityTag.vue?vue&type=script&lang=js"
import style0 from "./ListTraceabilityTag.vue?vue&type=style&index=0&id=26480872&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26480872')) {
      api.createRecord('26480872', component.options)
    } else {
      api.reload('26480872', component.options)
    }
    module.hot.accept("./ListTraceabilityTag.vue?vue&type=template&id=26480872", function () {
      api.rerender('26480872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/traceabilitytags/components/ListTraceabilityTag.vue"
export default component.exports